import { WHATSAPP } from "../data/content";
import { WhatsAppIcon } from "./WhatsAppButton";

export default function WhatsAppFloat() {
    return (
        <a
            href={WHATSAPP.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={WHATSAPP.label}
            data-testid="whatsapp-float"
            className="group fixed bottom-5 right-5 z-40 flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_28px_rgba(0,0,0,0.35)] hover:scale-105 hover:shadow-[0_14px_34px_rgba(0,0,0,0.45)] transition-transform duration-200"
        >
            <span className="pointer-events-none absolute right-full mr-3 hidden sm:block whitespace-nowrap bg-[#111318] text-white text-xs px-3.5 py-2 rounded-md opacity-0 translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 group-focus-visible:opacity-100 transition-all duration-200">
                {WHATSAPP.label}
            </span>
            <WhatsAppIcon className="h-7 w-7" />
        </a>
    );
}